import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { NbDialogRef } from '@nebular/theme';

/**
 * Component for prompt message to upgrade the subscription plan.
 */
@Component({
  selector: 'app-upgrade-plan',
  templateUrl: './upgrade-plan.component.html',
  styleUrls: ['./upgrade-plan.component.scss'],
})
export class UpgradePlanComponent {
  public Message =
    'You have reached the maximum amount of patient in your current plan. Upgrade plan to add a new patient.';

  SaveGoalLabel = 'Save';
  BackLabel = 'Back';

  protected readonly unsubscribe$ = new Subject<void>();

  constructor(
    private router: Router,
    private dialogRef: NbDialogRef<UpgradePlanComponent>,
  ) {}

  /**
   * It closes the dialog if it is opened on it.
   * If not, it goes back to the previous page.
   */
  Back() {
    this.dialogRef.close('cancel');
  }

  /**
   * It redirect to the profile page to upgrade the plan
   */
  Upgrade() {
    this.dialogRef.close();
    this.router.navigate(['/pages/CalorieFriend/manage-subscription']);
  }
}
